module.exports = __webpack_public_path__ + "img/cy.49cfcd51.png";